import Info from '../components/EnterInfo';
import PageLayout from '../components/pageLayout';

function InfoPage() {
    return (
        <PageLayout children={<Info />} />
    );
}

export default InfoPage;
